module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/lead_image3-a1070cfc80cca3bb5384b93e90411d17.jpg";